import { Department } from "@/domain/user";

export const DepartmentsName: Record<string, string> = {
	MSK: "установщики msk",
	SPB: "установщики spb",
	NN: "установщики nn",
	KRD: "установщики krd",
};

export const PAST_DAYS_EDIT_DEPARTMENTS = ["контроль исполнения", "администраторы"] as const;
export const INSTALLER_EQUIPMENT_REPORT_DEPARTMENTS = PAST_DAYS_EDIT_DEPARTMENTS;

export const isUserInDepartmentsByName = (
	departmentIds: number[] | undefined,
	allowedNames: readonly string[],
	departments: Department[],
): boolean => {
	if (!departmentIds?.length) return false;

	const allowedSet = new Set(allowedNames.map((name) => name.toLowerCase()));

	return departmentIds.some((id) => {
		const department = departments.find((dep) => dep.id === id);
		return department?.name && allowedSet.has(department.name.toLowerCase());
	});
};

export const findDepartmentsByName = (names: string[], departments: Department[]): Map<number, string> => {
	const searchedDepartmentsMap = new Map();

	for (const department of departments) {
		if (names.includes(department.name.toLowerCase())) {
			searchedDepartmentsMap.set(department.id, department.name);
		}
	}

	return searchedDepartmentsMap;
};
